<template>
  <v-container style="padding-bottom: 0px">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
         <!-- <v-card-media
            class="edomargintop hidden-sm-and-up"
            height="250px"
            :src="require('../assets/Edologic_UeberUnsv2.jpg')">
          </v-card-media> -->
          <v-card-media
            class="edomargintop"
            height="450px"
            :src="require('../assets/ueberuns.jpg')">
            <v-container fill-height>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <div class="edoschriftzentriertuns abstanduns">
                    <span class="ueberunstext">Wir sind edologic</span>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-media>
        </v-card>
      </v-flex>
    </v-layout>

    <v-container fluid grid-list-md>
      <v-layout row  wrap justify-space-around>
        <v-flex xs12 sm4 md4>
          <v-card flat>
            <v-card-media
              class="edomargintop"
              height="250px"
              :src="require('../assets/ueberuns_idee.png')">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex d-flex xs12 sm4 md4>
          <v-card class="edomargintop" flat>
            <v-card-title primary class="title edoheadlinetext">Die Idee</v-card-title>
            <v-card-text class="edoLineText">
              Leidenschaft, Freude am Entwickeln, Kreativität.<br>
              Für findige, smarte Köpfe wollten wir ein zu Hause schaffen.<br>
              Die sich austauschen können und zusammen etwas großes aufbauen.
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid grid-list-md>
      <v-layout row  wrap justify-space-around>
        <v-flex d-flex xs12 sm4 md4>
          <v-card class="edoborder" flat>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid grid-list-md>
      <v-layout row wrap justify-space-around>
        <v-flex d-flex xs12 sm4 md4>
          <v-card class="edomargintop" flat>
            <v-card-title primary class="title edoheadlinetext">Der Start</v-card-title>
            <v-card-text class="edoLineText">
              Im August 2008 war es soweit.
              Die edologic Rakete ist mit Matthias Ebel, Matthias Danzer und Michael Obermayer an den Start gegangen.
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-card flat>
            <v-card-media
              class="edomargintop"
              height="250px"
              :src="require('../assets/ueberuns_rakete.png')">
            </v-card-media>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid grid-list-md>
      <v-layout row  wrap justify-space-around>
        <v-flex d-flex xs12 sm4 md4>
          <v-card class="edoborder" flat>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid grid-list-md>
      <v-layout row  wrap justify-space-around>
        <v-flex xs12 sm4 md4>
          <v-card flat>
            <v-card-media
              class="edomargintop"
              height="250px"
              :src="require('../assets/ueberuns_stand.png')">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex d-flex xs12 sm4 md4>
          <v-card class="edomargintop" flat>
            <v-card-title primary class="title edoheadlinetext">Wir sind edologic</v-card-title>
            <v-card-text class="edoLineText">
              Seit zehn Jahren bietet die edologic unzähligen Projekten ein zu Hause – denn geniale Projekte beginnen hier.
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!--<v-container fluid grid-list-md>
      <v-layout row justify-space-around>
        <v-flex d-flex xs12 sm8 md8>
          <v-card class="edomargintop">
            <v-card-text class="edoLineText">
              Die edologic schafft Raum für Leidenschaft, Freude am Entwickeln, Kreativität – ein Gefühl von Heimat. Denn nur wer sich zu Hause fühlt kann großes schaffen. Um das Grundgerüst ins Leben zu rufen, haben im August 2008 Matthias Ebel, Matthias Danzer und  Michael Obermayer die edologic gegründet. Seither bietet die edologic unzähligen Projekten ein zu Hause – denn geniale Projekte beginnen hier.
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>-->
    <v-layout row wrap>
      <v-container>
        <v-card class="edoabstand">
        </v-card>
      </v-container>
    </v-layout>
    <v-container fluid grid-list-md class="hidden-sm-and-down">
      <v-layout row justify-space-around>
        <v-flex d-flex xs12>
          <v-carousel :cycle='false'>
            <!-- -->
            <v-carousel-item src="" style="background-color: #262e42">

              <v-layout row wrap justify-center>
                <v-flex d-flex xs12 sm5 md5>
                    <v-avatar
                      :tile="tile"
                      :size="avatarSize"
                      class="farbedunkel"
                    >
                      <img src="../assets/Matthias_Ebel.jpg" alt="avatar">
                    </v-avatar>
                </v-flex>
                <v-flex d-flex xs12 sm4 md4>
                  <v-card class="farbedunkel">
                  <v-card-title primary class="title edosliderhead paddingbottom5">
                    Matthias Ebel
                  </v-card-title>
                    <v-card-title class="paddingtop0">
                      <span style="color:#3781b6; font-size: large;font-weight: bold;">Geschäftsführer</span>
                    </v-card-title>
                  <v-card-text class="edoslidertext">
                    Matthias Ebel -
                    ein Softwareentwickler aus Leidenschaft.
                    Was 1996 im Keller entstand hat sich schnell zu einem Softwareunternehmen entwickelt.
                    2008 gründete er die edologic. Seit 2017 ist er alleiniger Geschäftsführer.
                    Sein Motto lautet: „Wenn dir jemand sagt: Das geht nicht! Denke immer daran: Das sind seine Grenzen, nicht deine!“
                </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-carousel-item>
            <!-- -->
            <v-carousel-item src="" style="background-color: #262e42">

              <v-layout row wrap justify-center>
                <v-flex d-flex xs12 sm5 md5>
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    class="farbedunkel"
                  >
                    <img src="../assets/Rebecca_Koch.jpg" alt="avatar">
                  </v-avatar>
                </v-flex>
                <v-flex d-flex xs12 sm4 md4>
                  <v-card class="farbedunkel">
                    <v-card-title primary class="title edosliderhead paddingbottom5">
                      Rebecca Koch
                    </v-card-title>
                    <v-card-title class="paddingtop0">
                      <span style="color:#3781b6; font-size: large;font-weight: bold;">Leitung Kreation</span>
                    </v-card-title>
                    <v-card-text class="edoslidertext">
                      Seit 2008 hat Rebecca Koch ihr zu Hause in der Kreation gefunden.
                      Mit Leidenschaft und Herz begegnet sie den Kunden um den perfekten Weg zu finden.
                      Ihr Motto ist "Machen ist wie wollen, nur krasser. Lassen Sie uns krasser sein"
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-carousel-item>

            <v-carousel-item src="" style="background-color: #262e42">

              <v-layout row wrap justify-center>
                <v-flex d-flex xs12 sm5 md5>
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    class="farbedunkel"
                  >
                    <img src="../assets/Einstein.jpg" alt="avatar">
                  </v-avatar>
                </v-flex>
                <v-flex d-flex xs12 sm4 md4>
                  <v-card class="farbedunkel">
                    <v-card-title primary class="title edosliderhead paddingbottom5">
                      Einstein
                    </v-card-title>
                    <v-card-title class="paddingtop0">
                      <span style="color:#3781b6; font-size: large;font-weight: bold;">Sportbeauftragter</span>
                    </v-card-title>
                    <v-card-text class="edoslidertext">
                      Wenn man mal nicht weiter kommt, weil der Kopf zu voll ist,
                      sorgt unser Sportbeauftragter Einstein mit etwas Bewegung dafür,
                      dass das Brainstorming an die frische Luft verlegt wird. Einstein trifft es immer auf den Punkt.
                      Sein Motto ist kurz und prägnant: "Wau"
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-carousel-item>

            <v-carousel-item src="" style="background-color: #262e42">

              <v-layout row wrap justify-center>
                <v-flex d-flex xs12 sm5 md5>
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    class="farbedunkel"
                  >
                    <img src="../assets/Team_erweitern.jpg" alt="avatar">
                  </v-avatar>
                </v-flex>
                <v-flex d-flex xs12 sm4 md4>
                  <v-card class="farbedunkel">
                    <v-card-title primary class="title edosliderhead paddingbottom5">
                      Dein Name?
                    </v-card-title>
                    <v-card-title class="paddingtop0">
                      <span
                        style="color:#3781b6; font-size: large;font-weight: bold;">Hier könnte dein Titel stehen</span>
                    </v-card-title>
                    <v-card-text class="edoslidertext">
                      Du möchtest unser Team verstärken? Suchst neue Heruasforderungen, ein tolles Arbeitsumfeld,
                      aufregende Kunden und hast Spaß an der Arbeit?
                      Dann schicke deine Initiativbewerbung an: <br><br>
                      <a href="mailto:info@edologic.de">info@edologic.de</a>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-carousel-item>

          </v-carousel>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid grid-list-md class="hidden-md-and-up">
      <v-layout row justify-space-around>
        <v-flex d-flex xs12>
          <v-carousel hide-controls  :cycle='false' class="carouseledomobil">

            <v-carousel-item src="" style="background-color: #262e42">

              <v-layout row wrap justify-center paddingtop50>
                <div itemscope itemtype="http://schema.org/Person">
                <v-flex d-flex xs12 sm5 md5>
                  <div itemprop="image">
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    class="farbedunkel"
                    alt="Matthias Ebel"
                  >
                    <img src="../assets/Matthias_Ebel.jpg" alt="avatar">
                  </v-avatar>
                  </div>
                </v-flex>
                <v-flex d-flex xs12 sm4 md4>
                  <v-card class="farbedunkel">
                    <v-card-title primary class="title edosliderhead paddingbottom5 paddingtop50">
                      <div itemprop="name">
                      Matthias Ebel
                      </div>
                    </v-card-title>
                    <v-card-title class="paddingtop0">
                      <span itemprop="disambiguatingDescription">
                      <span style="color:#3781b6; font-size: large;font-weight: bold;">Geschäftsführer</span>
                      </span>
                    </v-card-title>
                    <v-card-text class="edoslidertext">
                      <div itemprop="description">
                      Matthias Ebel -
                      ein Softwareentwickler aus Leidenschaft.
                      Was 1996 im Keller entstand hat sich schnell zu einem Softwareunternehmen entwickelt.
                      2008 gründete er die edologic. Seit 2017 ist er alleiniger Geschäftsführer.
                      Sein Motto lautet: „Wenn dir jemand sagt: Das geht nicht! Denke immer daran: Das sind seine Grenzen, nicht deine!“
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                </div>
              </v-layout>
            </v-carousel-item>

            <!--
            <v-carousel-item src="" style="background-color: #262e42">

              <v-layout row wrap justify-center>
                <v-flex d-flex xs12 sm5 md5>
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    class="farbedunkel"
                  >
                    <img src="../assets/Matthias_Ebel.jpg" alt="avatar">
                  </v-avatar>
                </v-flex>
                <v-flex d-flex xs12 sm4 md4>
                  <v-card class="farbedunkel">
                    <v-card-title primary class="title edosliderhead paddingbottom5">
                      Matthias Ebel
                    </v-card-title>
                    <v-card-title class="paddingtop0">
                      <span style="color:#3781b6; font-size: large;font-weight: bold;">Geschäftsführer</span>
                    </v-card-title>
                    <v-card-text class="edoslidertext">
                      Matthias Ebel -
                      ein Softwareentwickler aus Leidenschaft.
                      Was 1996 im Keller entstand hat sich schnell zu einem Softwareunternehmen entwickelt.
                      2008 gründete er die edologic. Seit 2017 ist er alleiniger Geschäftsführer.
                      Sein Motto lautet: „Wenn dir jemand sagt: Das geht nicht! Denke immer daran: Das sind seine Grenzen, nicht deine!“
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-carousel-item>
             -->
            <v-carousel-item src="" style="background-color: #262e42">

              <v-layout row wrap justify-center>
                <div itemscope itemtype="http://schema.org/Person">
                <v-flex d-flex xs12 sm5 md5>
                  <div itemprop="image">
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    class="farbedunkel"
                    alt="Rebecca Koch"
                  >
                    <img src="../assets/Rebecca_Koch.jpg" alt="avatar">
                  </v-avatar>
                  </div>
                </v-flex>
                <v-flex d-flex xs12 sm4 md4>
                  <v-card class="farbedunkel">
                    <v-card-title primary class="title edosliderhead paddingbottom5 paddingtop50">
                      <div itemprop="name">
                      Rebecca Koch
                      </div>
                    </v-card-title>
                    <v-card-title class="paddingtop0">
                      <span itemprop="disambiguatingDescription">
                      <span style="color:#3781b6; font-size: large;font-weight: bold;">Leitung Kreation</span>
                        </span>
                    </v-card-title>
                    <v-card-text class="edoslidertext">
                      <div itemprop="description">
                      Seit 2008 hat Rebecca Koch ihr zu Hause in der Kreation gefunden.
                      Mit Leidenschaft und Herz begegnet sie den Kunden um den perfekten Weg zu finden.
                      Ihr Motto ist "Machen ist wie wollen, nur krasser. Lassen Sie uns krasser sein"
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                </div>
              </v-layout>
            </v-carousel-item>

            <v-carousel-item src="" style="background-color: #262e42">

              <v-layout row wrap justify-center>
                <div itemscope itemtype="http://schema.org/Person">
                <v-flex d-flex xs12 sm5 md5>
                  <div itemprop="image">
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    class="farbedunkel"
                    alt="Einstein"
                  >
                    <img src="../assets/Einstein.jpg" alt="avatar">
                  </v-avatar>
                  </div>
                </v-flex>
                <v-flex d-flex xs12 sm4 md4>
                  <v-card class="farbedunkel">
                    <v-card-title primary class="title edosliderhead paddingbottom5 paddingtop50">
                      <div itemprop="name">
                      Einstein
                      </div>
                    </v-card-title>
                    <v-card-title class="paddingtop0">
                      <span itemprop="disambiguatingDescription">
                      <span style="color:#3781b6; font-size: large;font-weight: bold;">Sportbeauftragter</span>
                      </span>
                    </v-card-title>
                    <v-card-text class="edoslidertext">
                      <div itemprop="description">
                      Wenn man mal nicht weiter kommt, weil der Kopf zu voll ist,
                      sorgt unser Sportbeauftragter Einstein mit etwas Beweung dafür,
                      dass das Brainstorming an die frische Luft verlegt wird. Einstein trifft es immer auf den Punkt.
                      Sein Motto ist kurz und prägnant: "Wau"
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                </div>
              </v-layout>
            </v-carousel-item>

            <v-carousel-item src="" style="background-color: #262e42">

              <v-layout row wrap justify-center>
                <v-flex d-flex xs12 sm5 md5>
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    class="farbedunkel"
                  >
                    <img src="../assets/Team_erweitern.jpg" alt="avatar">
                  </v-avatar>
                </v-flex>
                <v-flex d-flex xs12 sm4 md4>
                  <v-card class="farbedunkel">
                    <v-card-title primary class="title edosliderhead paddingbottom5 paddingtop50">
                      Dein Name?
                    </v-card-title>
                    <v-card-title class="paddingtop0">
                      <span
                        style="color:#3781b6; font-size: large;font-weight: bold;">Hier könnte dein Titel stehen</span>
                    </v-card-title>
                    <v-card-text class="edoslidertext">
                      Du möchtest unser Team verstärken? Suchst neue Heruasforderungen, ein tolles Arbeitsumfeld,
                      aufregende Kunden und hast Spaß an der Arbeit?
                      Dann schicke deine Initiativbewerbung an: <br><br>
                      <a href="mailto:info@edologic.de">info@edologic.de</a>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-carousel-item>

          </v-carousel>
        </v-flex>
      </v-layout>
    </v-container>

    <v-layout row wrap>
      <v-container>
        <v-card class="edoabstandfooter">
        </v-card>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {},
    name: 'UeberUns',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Ueber Uns – wir sind es, die edologic',
      meta: [
        {
          name: 'description',
          content: 'Die edo Familie, wie alles begann und wer wir sind'
        }]
    },
    data: () => ({
      slider: 256,
      tile: false
    }),
    methods: {
    },
    mounted () {
      console.log('UeberUns')
    },
    computed: {
      avatarSize () {
        return `${this.slider}px`
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/UeberUns.vue